import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import TranslateText from "../../TranslateText";
import { templatesMessageSelector } from "../../../../services/selector/index.";
import "../../../../assets/style/modalStyle/detailProduct.scss";
import LabelInput from "../../LabelInput";
import { IconEditWhite } from "../../../../assets/icon";
import BaseButton from "../../Button/BaseButton";
import {
  getTemplatesMessageDetail,
  setOpenDetailTemplatesMessage,
  setOpenEditTemplatesMessage,
} from "../../../../services/slice/TemplatesMessage";
const ModalDetailTemplatesMessage = ({ title }) => {
  const dispatch = useDispatch();
  const stateTemplatesMessage = useSelector(templatesMessageSelector);
  const { idTemplatesMessage, isOpenModalDetail, dataTemplateMessageDetail } =
    stateTemplatesMessage;

  useEffect(() => {
    if (idTemplatesMessage) {
      dispatch(getTemplatesMessageDetail(idTemplatesMessage));
    }
  }, [dispatch, idTemplatesMessage]);

  const handCancel = () => {
    dispatch(setOpenDetailTemplatesMessage({ isOpen: false, id: "" }));
  };

  const handleEditGroupNotification = () => {
    dispatch(setOpenDetailTemplatesMessage({ isOpen: false, id: "1" }));
    dispatch(setOpenEditTemplatesMessage({ isOpen: true, id: "1" }));
  };
  const [html, setHtml] = useState("");

  useEffect(() => {
    setHtml(dataTemplateMessageDetail?.content);
  }, [html, dataTemplateMessageDetail?.content]);
  return (
    <>
      <Modal
        className="wrapperModalDetailProduct"
        title={<TranslateText text={title} />}
        centered
        width={1000}
        open={isOpenModalDetail}
        onCancel={handCancel}
        footer={[
          // <BaseButton
          //   content={"Chỉnh sửa"}
          //   width={140}
          //   typeBtn="btnOrange"
          //   icon={<IconEditWhite />}
          //   handleClick={handleEditGroupNotification}
          // />,
        ]}
      >
        <Row style={{ display: "flex" }}>
          <Col span={5}>
            {" "}
            <LabelInput text={"Tiêu đề"} style={{ textAlign: "start" }} />
          </Col>
          <Col style={{fontWeight:'bold'}} span={18}>{dataTemplateMessageDetail?.title}</Col>
        </Row>
        <Row
          style={{ display: "flex", marginTop: "32px", marginBottom: "8px" }}
        >
          <Col span={5}>
            {" "}
            <LabelInput
              text={"Nội dung tin nhắn"}
              style={{ textAlign: "start" }}
            />
          </Col>
          <Col span={18} className="rightContent">
            <div dangerouslySetInnerHTML={{ __html: html }}></div>
            {/* <TextInput text={dataTemplateMessageDetail?.content}></TextInput> */}
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default ModalDetailTemplatesMessage;

export const TextInput = ({ text, style }) => {
  return (
    <span
      style={{
        display: "block",
        width: "100%",
        textAlign: "start",
        fontWeight: 400,
        fontFamily: "Roboto",
        fontSize: "14px",
        ...style,
      }}
    >
      <TranslateText text={text} />
    </span>
  );
};
